import React, { useState, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { createLink } from '@meshconnect/web-link-sdk'
import { getMeshPayLinkTokenService } from 'network/services/payment.service'
import { setShowWalletPopup } from 'redux-thunk/redux/slices/wallet.slice'
import Loader from 'components/ui-kit/Loader'
import { LOADER_HANDLER_TYPES } from 'constants/index'

const MESH_TO_ADDRESSES = [
  {
    networkId: 'e3c7fdd8-b1fc-4e51-85ae-bb276e075611',
    symbol: 'USDC',
    address: process.env.REACT_APP_MESH_ETH_ADDRESS || ''
  },
  {
    networkId: 'aa883b03-120d-477c-a588-37c2afd3ca71',
    symbol: 'USDC',
    address: process.env.REACT_APP_MESH_BASE_ADDRESS || ''
  },
  {
    networkId: '0291810a-5947-424d-9a59-e88bb33e999d',
    symbol: 'USDC',
    address: process.env.REACT_APP_MESH_SOL_ADDRESS || ''
  }
]

export const Deposit = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleMeshDeposit = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const res = await getMeshPayLinkTokenService({ toAddresses: MESH_TO_ADDRESSES })
      const linkToken = res?.data?.linkToken

      if (!linkToken) {
        setError(t('depositFailed') || 'Failed to get deposit token. Try again.')
        return
      }

      const connection = createLink({
        renderType: 'overlay',
        theme: 'system',
        language: 'system',
        displayFiatCurrency: 'USD',
        onIntegrationConnected: (payload) => {
          console.log('[Mesh] integration connected', payload)
        },
        onTransferFinished: (payload) => {
          console.log('[Mesh] transfer finished', payload)
          dispatch(setShowWalletPopup(false))
        },
        onExit: () => {
          console.log('[Mesh] exited')
        },
        onEvent: (ev) => {
          console.log('[Mesh] event', ev)
        }
      })

      connection.openLink(linkToken)
    } catch (err) {
      setError(t('depositFailed') || 'Deposit failed. Please try again.')
    } finally {
      setLoading(false)
    }
  }, [dispatch, t])

  return (
    <div className='tab-pane fade show active text-white' id='pills-deposit' role='tabpanel' aria-labelledby='pills-home-tab'>
      <div className='row g-2 p-2'>
        <p className='text-muted mb-3' style={{ fontSize: '14px' }}>
          Deposit crypto directly from your exchange or wallet via Mesh.
        </p>

        {error && (
          <div className='alert alert-danger py-2 px-3 mb-2' style={{ fontSize: '13px' }}>
            {error}
          </div>
        )}

        <div>
          <button
            type='button'
            className='btn btn-primary mt-2 mb-3'
            style={{ width: '100%', lineHeight: '40px' }}
            onClick={handleMeshDeposit}
            disabled={loading}
          >
            {loading
              ? <Loader variant={LOADER_HANDLER_TYPES.submit} />
              : (t('deposit') || 'Deposit via Mesh')}
          </button>
        </div>
      </div>
    </div>
  )
}
